import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaRegClock, FaShieldAlt, FaMoneyBillWave, FaPlane, FaHeadset, FaLock } from "react-icons/fa";
import "./WhyBook.css";

const WhyBook = () => {
  const features = [
    {
      icon: <FaRegClock />,
      title: "Instant & Full Refunds",
      desc: "Get your refunds instantly with our assured service, hassle-free.",
    },
    {
      icon: <FaShieldAlt />,
      title: "Travel Stress-Free",
      desc: "Comprehensive travel insurance for a worry-free journey.",
    },
    {
      icon: <FaMoneyBillWave />,
      title: "Smart Fare Alerts",
      desc: "Save up to 40% with intelligent fare alerts for your flights.",
    },
    {
      icon: <FaPlane />,
      title: "Flight Tracking",
      desc: "Track flight delays, boarding gates, and baggage belts in real time.",
    },
    {
      icon: <FaHeadset />,
      title: "24x7 Support",
      desc: "Our dedicated customer support is available around the clock.",
    },
    {
      icon: <FaLock />,
      title: "Price Lock",
      desc: "Lock your fare now and book later without worrying about price changes.",
    },
  ];

  return (
    <Container className="WhyBook-container my-5">
      <h2 className="WhyBook-heading text-center mb-5">
        Why Book With <span className="WhyBook-highlight">VolarPro?</span>
      </h2>

      <Row className="WhyBook-features-grid">
        {features.map((feature, idx) => (
          <Col key={idx} md={4} sm={6} className="mb-4">
            <div className="WhyBook-feature-card text-center">
              <div className="WhyBook-icon">{feature.icon}</div>
              <h5 className="WhyBook-feature-title">{feature.title}</h5>
              <p className="WhyBook-feature-desc">{feature.desc}</p>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default WhyBook;
